import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const socialChatRoot = (state: State) => state.socialChat;

export const instagramConversationsSelector = createSelector(
  socialChatRoot,
  (me) => {
    return {
      active: me.instagram.active.ids.map(
        (id) => me.instagram.active.entities[id]
      ),
      archived: me.instagram.archived.ids.map(
        (id) => me.instagram.archived.entities[id]
      ),
      inTrash: me.instagram.inTrash.ids.map(
        (id) => me.instagram.inTrash.entities[id]
      ),
    };
  }
);
export const dateFilterSelector = createSelector(
  socialChatRoot,
  (me) => me.dateFilter
);

export const instagramSelectedSelector = createSelector(
  socialChatRoot,
  (me) => me.instagram.selected
);
export const instagramMessagesSelector = createSelector(socialChatRoot, (me) =>
  me.instagram.messages.ids.map((id) => me.instagram.messages.entities[id])
);

export const facebookConversationsSelector = createSelector(
  socialChatRoot,
  (me) => {
    return {
      active: me.facebook.active.ids.map(
        (id) => me.facebook.active.entities[id]
      ),
      archived: me.facebook.archived.ids.map(
        (id) => me.facebook.archived.entities[id]
      ),
      inTrash: me.facebook.inTrash.ids.map(
        (id) => me.facebook.inTrash.entities[id]
      ),
    };
  }
);
export const facebookSelectedSelector = createSelector(
  socialChatRoot,
  (me) => me.facebook.selected
);
export const facebookMessagesSelector = createSelector(socialChatRoot, (me) =>
  me.facebook.messages.ids.map((id) => me.facebook.messages.entities[id])
);

export const whatsappConversationsSelector = createSelector(
  socialChatRoot,
  (me) => {
    return {
      active: me.whatsapp.active.ids.map(
        (id) => me.whatsapp.active.entities[id]
      ),
      archived: me.whatsapp.archived.ids.map(
        (id) => me.whatsapp.archived.entities[id]
      ),
      inTrash: me.whatsapp.inTrash.ids.map(
        (id) => me.whatsapp.inTrash.entities[id]
      ),
    };
  }
);
export const whatsappSelectedSelector = createSelector(
  socialChatRoot,
  (me) => me.whatsapp.selected
);

export const whatsappMessagesSelector = createSelector(socialChatRoot, (me) =>
  me.whatsapp.messages.ids.map((id) => me.whatsapp.messages.entities[id])
);

const emptyGroup = { active: [], archived: [], inTrash: [] };

export const linkedinConversationsSelector = createSelector(
  socialChatRoot,
  (me) => {
    const li = me.linkedin;
    if (!li?.active?.ids) return emptyGroup;
    return {
      active: li.active.ids.map((id) => li.active.entities[id]),
      archived: li.archived.ids.map((id) => li.archived.entities[id]),
      inTrash: li.inTrash.ids.map((id) => li.inTrash.entities[id]),
    };
  }
);
export const linkedinSelectedSelector = createSelector(
  socialChatRoot,
  (me) => me.linkedin?.selected ?? null
);
export const linkedinMessagesSelector = createSelector(socialChatRoot, (me) =>
  me.linkedin?.messages?.ids?.length
    ? me.linkedin.messages.ids.map((id) => me.linkedin!.messages.entities[id])
    : []
);

export const linkedinBusinessConversationsSelector = createSelector(
  socialChatRoot,
  (me) => {
    const lb = me.linkedinBusiness;
    if (!lb?.active?.ids) return emptyGroup;
    return {
      active: lb.active.ids.map((id) => lb.active.entities[id]),
      archived: lb.archived.ids.map((id) => lb.archived.entities[id]),
      inTrash: lb.inTrash.ids.map((id) => lb.inTrash.entities[id]),
    };
  }
);
export const linkedinBusinessSelectedSelector = createSelector(
  socialChatRoot,
  (me) => me.linkedinBusiness?.selected ?? null
);
export const linkedinBusinessMessagesSelector = createSelector(
  socialChatRoot,
  (me) =>
    me.linkedinBusiness?.messages?.ids?.length
      ? me.linkedinBusiness.messages.ids.map(
          (id) => me.linkedinBusiness!.messages.entities[id]
        )
      : []
);
